import { Table as AntdTable } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  AggregateColumnHeader as ACH,
  GroupColumnHeader as GCH,
  getMockData
} from '../components';

const defaultProps = {
  fieldsMetaData: [],
  report: {},
  slotData: {}
};
const propTypes = {
  tableData: PropTypes.array.isRequired,
  id: PropTypes.number.isRequired,
  fieldsMetaData: PropTypes.array,
  report: PropTypes.object,
  slotData: PropTypes.object
};

class Table extends Component {
  componentDidMount() {}

  renderColumns = () => {
    const { id } = this.props;
    return [
      { dataIndex: 'group', width: '50%', title: <GCH id={id} /> },
      { dataIndex: 'aggregate', width: '50%', title: <ACH id={id} /> }
    ];
  };

  render() {
    const { tableData } = this.props;
    return (
      <AntdTable
        columns={this.renderColumns()}
        dataSource={tableData}
        rowKey="id"
        size="small"
        pagination={false}
      />
    );
  }
}

const mapStateToProps = ({ metaData, dashboardSettings }, ownProps) => {
  // find slot data
  const { id } = ownProps;
  const slotData = dashboardSettings.details.slots.find(s => s.id === id) || {};

  // find report
  const { reportId } = slotData;
  const report = metaData.reports.data.find(r => r.id === reportId) || {};

  const { orderSettings = {} } = slotData;
  return {
    fieldsMetaData: metaData.fields.data,
    report,
    slotData,
    // Notes: due to slotData in OO way, so we use following keys to make sure if mock data should be re-generated.
    sortField: orderSettings.field_name,
    sortOrder: orderSettings.direction
  };
};
Table.defaultProps = defaultProps;
Table.propTypes = propTypes;

const enhancers = compose(
  connect(mapStateToProps),
  getMockData
);
export default enhancers(Table);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/container/index.jsx